import { useMemo } from 'react';
import { erstelleAbgleich } from './abgleich';
import type {
  AbgleichZeile,
  MitarbeiterabgleichQuelle,
  MitarbeiterabgleichZusammenfassung,
} from './entities/Mitarbeiterabgleich';
import { MOCK_MITARBEITERABGLEICH_QUELLE } from './mock/mitarbeiterabgleich.mock';

function useMitarbeiterabgleichQuelle(): {
  quelle?: MitarbeiterabgleichQuelle;
  error?: string;
} {
  return { quelle: MOCK_MITARBEITERABGLEICH_QUELLE };
}

type MitarbeiterabgleichErgebnis = {
  zeilen: AbgleichZeile[];
  zusammenfassung?: MitarbeiterabgleichZusammenfassung;
  error?: string;
};

export function useMitarbeiterabgleich(): MitarbeiterabgleichErgebnis {
  const { quelle, error } = useMitarbeiterabgleichQuelle();

  return useMemo<MitarbeiterabgleichErgebnis>(() => {
    if (!quelle) {
      return { zeilen: [], error };
    }

    const { zeilen, gesamt, uebereinstimmend } = erstelleAbgleich(
      quelle.e2nMitarbeiter,
      quelle.datevMitarbeiter,
    );

    return {
      zeilen,
      zusammenfassung: {
        gesamt,
        uebereinstimmend,
        letzterAbruf: quelle.letzterAbruf,
      },
    };
  }, [quelle, error]);
}
